import React, { memo, SVGProps } from 'react'

export const Checklist = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M16.9132 4.3118H14.7991C14.4957 2.98886 13.3588 2 12.0016 2C10.6443 2 9.50745 2.98886 9.20407 4.3118H7.08995C5.65925 4.3118 4.5 5.5245 4.5 7.01782V17.2973C4.5 18.7906 5.65925 20.0033 7.08676 20.0033H16.9132C18.3407 20.0033 19.5 18.7906 19.5 17.2973V7.01782C19.5 5.5245 18.3407 4.3118 16.9132 4.3118ZM11.9984 3.40312C12.8479 3.40312 13.5377 4.12472 13.5377 5.01336C13.5377 5.902 12.8479 6.62361 11.9984 6.62361C11.1489 6.62361 10.4591 5.902 10.4591 5.01336C10.4591 4.12472 11.1489 3.40312 11.9984 3.40312ZM18.1587 17.294C18.1587 18.0122 17.5999 18.5969 16.9132 18.5969H7.08676C6.40015 18.5969 5.84128 18.0122 5.84128 17.294V7.01782C5.84128 6.29955 6.40015 5.71492 7.08676 5.71492H9.20087C9.50426 7.03786 10.6412 8.02673 11.9984 8.02673C13.3557 8.02673 14.4925 7.03786 14.7959 5.71492H16.91C17.5967 5.71492 18.1555 6.29955 18.1555 7.01782V17.2973L18.1587 17.294Z"
      fill="currentColor"
    />
    <path
      d="M15.6646 9.78396H8.33223C7.96178 9.78396 7.66159 10.098 7.66159 10.4855C7.66159 10.8731 7.96178 11.1871 8.33223 11.1871H15.6646C16.035 11.1871 16.3352 10.8731 16.3352 10.4855C16.3352 10.098 16.035 9.78396 15.6646 9.78396Z"
      fill="currentColor"
    />
    <path
      d="M15.6646 13.7929H8.33223C7.96178 13.7929 7.66159 14.1069 7.66159 14.4944C7.66159 14.882 7.96178 15.196 8.33223 15.196H15.6646C16.035 15.196 16.3352 14.882 16.3352 14.4944C16.3352 14.1069 16.035 13.7929 15.6646 13.7929Z"
      fill="currentColor"
    />
  </svg>
))
